import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./store";
import { FilterProvider } from "./context/FilterContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RoleProvider } from "./context/RolesContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const client = new QueryClient();

root.render(
  <>
    <QueryClientProvider client={client}>
      <Provider store={store}>
        <RoleProvider>
          <FilterProvider>
            <App />
          </FilterProvider>
          <ToastContainer />
        </RoleProvider>
      </Provider>
    </QueryClientProvider>
  </>
);
